'use strict';

import React from 'react';
import { connect } from 'react-redux';
import AutoCompleteSearch from './AutoCompleteSearch';
import { updateNetworkOfflineMessage } from '../../../actions/networkStatus';
import { updateActiveQuery } from '../../../actions/header/autocomplete';
import { networkOnlineSelector } from '../../../reducers/network';
import { autocompleteActiveQuerySelector } from 'app/reducers/autocomplete';

const AutoCompleteSearchFormContainer = (props) => <AutoCompleteSearch {...props} />;

const mapDispatchToProps = (dispatch) => {
    return {
        updateActiveQuery: (query) => {
            dispatch(updateActiveQuery({ query: query }));
        },
        updateNetworkOfflineMessage: (isVisible, targetUrl) => {
            dispatch(updateNetworkOfflineMessage(isVisible, targetUrl));
        },
    };
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        activeResult: autocompleteActiveQuerySelector(state),
        networkOnline: networkOnlineSelector(state),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoCompleteSearchFormContainer);
